export default __webpack_public_path__ + "static/media/home-banner.51403117.jpg";